import { ColumnInfo } from "../../../../models/column-info";
import { alignment } from "../../models/alignment.enum";
import { bodiesEnum } from "./bodies.enum";
import { coreType } from "./core-type.enum";
import { defaultCore } from "./core-types.model";
import { crownType } from "./crown-type.enum";
import { headType } from "./head-type.enum";
import { defaultHead } from "./head-types.model";
import { middleType } from "./middle-type.enum";
import { plinthType } from "./plinth-type.enum";
import { partTypeEnum } from "./part-type.enum";
import { Part, RefinedParts } from "../../models/part";
import { Column, UnitAmount } from "../../models/column";
import { columnType } from "./column-type.enum";
import { segmentType } from "./segment-type";
import { subtypeEnum, variantEnum } from "./column-definition";
import { unitBaseTypeEnum } from "../../../../unit-base-type-enum";
import { UnitWish } from "../../../../models/unit-wish-list";
import { InitialProps } from "../../Common/BuildingInitialPropertiesDialog/init-props";

export type TowerColumn = Column<columnType | headType, segmentType, subtypeEnum, variantEnum>;
export type TowerPart = Part<TowerColumn, partTypeEnum>;
export type TowerRefinedParts = RefinedParts<TowerColumn, partTypeEnum>;

export const defaultUnitWishList: UnitWish[] = [
    {
        type: unitBaseTypeEnum.C_XS,
        uiName: 'XS',
        percentage: 25,
    },
    {
        type: unitBaseTypeEnum.C_S,
        uiName: 'S',
        percentage: 25,
    },
    {
        type: unitBaseTypeEnum.C_M,
        uiName: 'M',
        percentage: 25,
    },
    {
        type: unitBaseTypeEnum.C_XL,
        uiName: 'XL',
        percentage: 25,
    },
]

export type PropsTower = {
    buildingWidth: number;
    buildingLength: number;
    buildingHeight: number;
    plinthType: plinthType;
    middleType: middleType;
    crownType: crownType;
    plinthFloors: number;
    customPlinthHeight: number;
    customPlinthWidth: number;
    crownFloors: number;
    moosPlazaType: columnType;
    moosPlazaAlignment: alignment;
    moosPlazaPosition: bodiesEnum;
    moosPlazaBays: number;
    selectedHeadType: headType;
    selectedCoreType: coreType;
    unitWishList: { type: unitBaseTypeEnum, percentage: number }[];
    totalPercentageC: number;
    amount_C_M_Columns: number;
    amount_C_S1S2_Columns: number;
    amount_C_L_Columns: number;
    parts: TowerPart[];
    partsRefined: TowerRefinedParts[];
    info: ColumnInfo;
    totalAmountOfAllUnits: UnitAmount[];
}

export const getDefaultPropsTower = (initProps: InitialProps): PropsTower => {
    let unitWishList = initProps.unitWishList.length > 0 ? initProps.unitWishList : defaultUnitWishList;
    return {
        buildingWidth: 21,
        buildingLength: 132,
        buildingHeight: 30,
        plinthType: plinthType.C,
        middleType: middleType.C,
        crownType: crownType.C,
        plinthFloors: 2,
        customPlinthHeight: 0,
        customPlinthWidth: 0,
        crownFloors: 1,
        moosPlazaType: columnType.V_P3T_S,
        moosPlazaAlignment: alignment.center,
        moosPlazaPosition: bodiesEnum.A,
        moosPlazaBays: 3,
        selectedHeadType: defaultHead,
        selectedCoreType: defaultCore,
        unitWishList,
        totalPercentageC: 100,
        amount_C_M_Columns: 0,
        amount_C_S1S2_Columns: 0,
        amount_C_L_Columns: 0,
        parts: [],
        info: {
            totalGFA: 0,
            totalUFA: 0,
        },
        totalAmountOfAllUnits: [],
        partsRefined: [],
    }
}